import { useContext } from "react";
import ResourcesUniversitySpacesContext from "./ResourcesUniversitySpacesContext";

const useResourcesUniversitySpacesContext = () => {
    return useContext(ResourcesUniversitySpacesContext);
}

export default useResourcesUniversitySpacesContext;